import React, { useEffect } from "react";

import { useTranslation } from "react-i18next";

import DesktopLayout from "@components-shared/desktop/layout/DesktopLayout";
import { HeaderType } from "@data-types/layout/headerTypeEnum";
import { redirectUserToHomePageAfterRegistration } from "@utils";

import { OnBoardingFooter, OnBoardingSlider } from "../shared";

export default function RegistrationError() {
	const { t } = useTranslation("registration");

	const redirectToHomePage = () => {
		redirectUserToHomePageAfterRegistration();
	};

	useEffect(() => {
		window.scrollTo(0, 0);
	}, []);

	return (
		<DesktopLayout
			headerType={HeaderType.EMPTY}
			mainClassName="at-RegistrationError l--main l--main--grow"
		>
			<section className="l--content l--content--full">
				<div className="l--content__main u-padd--reset">
					<div className="container container--med container--grow">
						<div className="card--onboarding card--onboarding--grow card--shadowy">
							<OnBoardingSlider />
							<div className="card--onboarding__form card--onboarding__form--center">
								<div className="card--onboarding__header card--onboarding__header--vertical">
									<i className="u-icon u-icon--xxxlrg u-icon--remove-circle u-icon--animated--bounce-in u-color--sent--danger" />
									<div className="u-mar--top--med u-type--xlrg u-type--wgt--medium u-type--center">
										{t("ERROR_HAS_OCCURED")}
									</div>
								</div>

								<div className="card--onboarding__content card--onboarding__content--shrink">
									<div>{t("GENERIC_ERROR")}</div>
								</div>

								<button
									className="at-regErrorBtnHome btn btn--base btn--block btn--accent"
									onClick={redirectToHomePage}
								>
									{t("COMMON.BACK_TO_HOME_PAGE")}
								</button>
							</div>
						</div>

						<OnBoardingFooter />
					</div>
				</div>
			</section>
		</DesktopLayout>
	);
}
